import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, BaseViewConfigService, ProductAssortmentParentService, ProductInlineSearchCardComponent, ProductInlineSearchListConfigService, SelectedCustomerService } from 'gung-standard';
import { environment } from 'projects/tylo/src/environments/environment';
import { TyloPriceConfigService } from '../../services/tylo-price-config.service';
import { first, forkJoin, of, switchMap } from 'rxjs';

@Component({
    selector: 'tylo-inline-search-card',
    templateUrl: './tylo-inline-search-card.component.html',
    styleUrls: ['./tylo-inline-search-card.component.css'],
    standalone: false
})
export class TyloInlineSearchCardComponent extends ProductInlineSearchCardComponent implements OnInit {
  finnishCustomerWithD = false;
  projectName = environment.projectName;
  showB2CPrices: boolean = false;

  constructor(
    protected router: Router,
    protected productInlineSearchListConfigService: ProductInlineSearchListConfigService,
    protected authService: AuthService,
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService,
    protected selectedCustomerService: SelectedCustomerService,
    protected priceConfigService: TyloPriceConfigService
  ) {
    super(router, productInlineSearchListConfigService, baseViewConfigService, productAssortmentParentService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.selectedCustomerService.getSelectedCustomer().pipe(
      switchMap(selectedCustomer => forkJoin({
        customer: of(selectedCustomer),
        customerPriceMarkup: this.priceConfigService.getB2CPriceMarkup(selectedCustomer.id).pipe(first())
      }))
    ).subscribe(({ customer, customerPriceMarkup }) => {
      if (customer.id.toLowerCase().startsWith('d')) {
        this.finnishCustomerWithD = true;
      }

      if (!!customerPriceMarkup) {
        if (!this.data.extra.price.extra) {
          this.data.extra.price.extra = {};
        }
        this.data.extra.price.extra.b2cPrice = this.priceConfigService.calculatePriceMarkup(customerPriceMarkup, this.data.extra.price.customerGrossPrice?.value || 0);
      }
    });
    this.priceConfigService.showB2CPrices.subscribe(showB2CPrices => this.showB2CPrices = showB2CPrices);
  }
}
